module.exports = __webpack_public_path__ + "static/media/remove-btn.09a99e53.svg";